// extracted by mini-css-extract-plugin
export default {"container":"dashboard_container__dZX+F","menu":"dashboard_menu__NK4Ee"};